function pad(num, length, fill) {
    if (fill === void 0) { fill = '0'; }
    var len = ('' + num).length;
    return (Array(length > len ? length - len + 1 || 0 : 0).join(fill) + num);
}
var fillStr = Array.prototype.fill ?
    function (str, start, end, fill) {
        return str.split('').fill(fill, start, end).join('');
    } :
    function (str, start, end, fill) {
        /* istanbul ignore next */
        if (end == null) {
            end = str.length;
        }
        return str.substring(0, start) +
            Array.apply(null, { length: end - start }).map(function (_) { return fill; }).join('')
            + str.substring(end);
    };
var Format = /** @class */ (function () {
    function Format() {
    }
    /**
    * 时间格式化
    * @example format 支持下面的格式：
    * 年份：dateFormat(date, yyyy) => 2018
    * 2 位数月份：dateFormat(date, MM) => 02
    * 1 位数月份：dateFormat(date, M) => 2
    * 2 位数日期：dateFormat(date, dd) => 07
    * 1 位数日期：dateFormat(date, d) => 7
    * 2 位数 24 小时：dateFormat(date, HH) => 09
    * 1 位数 24 小时：dateFormat(date, H) => 11
    * 2 位数 12 小时(上下午会在小时前加 AM/PM)：dateFormat(date, hh) => 02
    * 1 位数 12 小时(上下午会在小时前加 AM/PM)：dateFormat(date, h) => 2
    * 2 位数分钟：dateFormat(date, mm) => 08
    * 1 位数分钟：dateFormat(date, mm) => 8
    * 2 位数秒：dateFormat(date, ss) => 06
    * 1 位数秒：dateFormat(date, s) => 6
    * 3 位数毫秒：dateFormat(date, S) => 000
    * 季度：dateFormat(date, q) => 1
    * @param date
    * @param format
    */
    Format.dateFormat = function (date, format) {
        if (format === void 0) { format = 'yyyy-MM-dd'; }
        /* istanbul ignore if */
        if (!date)
            return '';
        var converDate;
        if (!(date instanceof Date)) {
            var tmp = String(date).replace(/\-/g, '/');
            /* istanbul ignore if */
            if (!isNaN(tmp)) {
                tmp = parseInt(tmp, 10);
            }
            converDate = new Date(tmp);
        }
        else {
            converDate = date;
        }
        /* istanbul ignore if */
        if (!(converDate instanceof Date))
            return '';
        converDate = converDate;
        var hours = converDate.getHours();
        var hours12 = hours > 11 ? 'PM' + (hours - 12) : 'AM' + hours; // 12 小时制 1 位数
        var hours12double = hours > 11 ? 'PM ' + pad(hours - 12, 2) : 'AM ' + pad(hours, 2); // 12 小时制 2 位数
        var o = {
            'M+': converDate.getMonth() + 1,
            'd+': converDate.getDate(),
            'H+': converDate.getHours(),
            'm+': converDate.getMinutes(),
            's+': converDate.getSeconds(),
            'q+': Math.floor((converDate.getMonth() + 3) / 3),
            'S': converDate.getMilliseconds(),
        };
        format = format
            .replace('yyyy', converDate.getFullYear()) // 4位数年份
            .replace('hh', hours12double) // 12 小时制 2 位数
            .replace('h', hours12); // 12 小时制 1 位数
        for (var k in o) {
            if (new RegExp('(' + k + ')').test(format)) {
                format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
            }
        }
        return format;
    };
    /**
     * 打掩码
     * @example setMask('demo', 1) => d***
     * @example setMask('demo', 1, 2) => d*mo
     * @example setMask('demo', 1, '$') => d$$$
     * @example setMask('demo', 1, 3, '$') => d$$o
     * @param str 要打掩码的字符串
     * @param start 掩码开始位置索引
     * @param end 掩码结束位置索引
     * @param fill 掩码字符
     */
    Format.setMask = function (str, start, end, fill) {
        if (fill === void 0) { fill = '*'; }
        /* istanbul ignore if */
        if (!str)
            return '';
        str = str + '';
        if (typeof end === 'string') {
            fill = end;
            end = void 0;
        }
        var len = str.length;
        return fillStr(str, start, end, fill);
    };
    /**
     * 固定数字精度
     * @example toFixed('1.123123', 1) => 1.1
     * @param value 数字
     * @param precision 精度
     * @param rounding 是否四舍五入
     */
    Format.toFixed = function (value, precision, rounding) {
        if (precision === void 0) { precision = 0; }
        if (rounding === void 0) { rounding = true; }
        var exponentialForm = Number(value + 'e' + precision);
        var rounded = rounding ? Math.round(exponentialForm) : Math.floor(exponentialForm);
        return Number(rounded + 'e-' + precision).toFixed(precision);
    };
    /**
     * 数字按照千位分割
     * @example seperateThousand(12312323.123123) => 12,312,323.123123
     * @param value 数字
     * @param seperator 分隔符
     */
    Format.seperateThousand = function (value, seperator) {
        if (seperator === void 0) { seperator = ','; }
        var negative = value < 0 ? '-' : '';
        var parts = ("" + value).split('.');
        // @ts-ignore
        var base = parseInt(Math.abs(parts[0] || 0), 10) + '';
        // @ts-ignore
        var decimal = parts[1] || '';
        var mod = base.length > 3 ? base.length % 3 : 0;
        return negative + (mod ? base.substr(0, mod) + seperator : '') + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + seperator) + (decimal ? "." + decimal : '');
    };
    /**
     * 分转万
     *
     * @param {number} num - 分
     * @param {number} [precision=2] - 保留小数点； 传入负数时，保留两位小数截断
     * @param {boolean} [isDivideByComma=false] - 分隔符
     * @return {number}
     */
    Format.fenToWan = function (num, precision, isDivideByComma) {
        if (precision === void 0) { precision = 2; }
        if (isDivideByComma === void 0) { isDivideByComma = false; }
        var val = parseFloat(num);
        /* istanbul ignore if */
        if (isNaN(val))
            return num;
        if (!val || val === 0) {
            val = 0;
        }
        else {
            val = val / 1000000;
        }
        if (precision < 0) {
            val = Format.toFixed(val, 2, false);
        }
        else {
            val = Format.toFixed(val, precision);
        }
        if (isDivideByComma) {
            val = parseFloat(val).toLocaleString();
        }
        return val;
    };
    /**
     * 分转元
     *
     * @param {number} num - 分
     * @param {number} [precision=2] - 保留小数点；传入负数时，保留两位小数截断
     * @param {boolean} [isDivideByComma=false] - 分隔符
     * @return {number|string}
     */
    Format.fenToYuan = function (num, precision, isDivideByComma) {
        if (precision === void 0) { precision = 2; }
        if (isDivideByComma === void 0) { isDivideByComma = false; }
        var val = parseFloat(num);
        /* istanbul ignore if */
        if (isNaN(val))
            return num;
        if (!val || val === 0) {
            val = 0;
        }
        else {
            val = val / 100;
        }
        if (precision < 0) {
            val = Format.toFixed(val, 2, false);
        }
        else {
            val = Format.toFixed(val, precision);
        }
        if (isDivideByComma) {
            val = parseFloat(val).toLocaleString();
        }
        return val;
    };
    return Format;
}());
export default Format;
